import PropTypes from 'prop-types'
import $ from 'jquery'
import React, { Component } from 'react'
import debounce from 'lodash/debounce'

import Scroller from 'mobile/components/layout/scroller'
import Dropdown from 'mobile/views/application/chrome/dropdown'

class Tray extends Component {
  static propTypes = {
    children: PropTypes.any,
    title: PropTypes.string,
    onRequestClose: PropTypes.func,
    shouldDropDown: PropTypes.bool,
    onScrollEnd: PropTypes.func,
    showHeader: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    closeIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    className: PropTypes.string,
  }

  static defaultProps = {
    shouldDropDown: true,
    showHeader: true,
    showCloseButton: true,
  }

  componentDidMount() {
    this.refreshScroller()

    if (this.props.onScrollEnd) {
      const debouncedScrollEnd = debounce(this.props.onScrollEnd, 300)
      this.refs.scroller.onScrollEnd(debouncedScrollEnd)
      $(window).scroll(debouncedScrollEnd)
    }
  }

  componentDidUpdate() {
    return this.refreshScroller()
  }

  refreshScroller() {
    // HACK: Delay to let animations (specifically height changes) complete
    return setTimeout(() => {
      return this.refs.scroller != null ? this.refs.scroller.refresh() : undefined
    }, 500)
  }

  scrollToElement(el) {
    return this.refs.scroller != null ? this.refs.scroller.scrollToElement(el) : undefined
  }

  render() {
    const header = (() => {
      if (this.props.title) {
        return (
          <div className="checkout-tray__header">
            <span className="checkout-tray__title">{this.props.title}</span>
            {this.props.showCloseButton && (
              <span className="checkout-tray__close-button" onClick={this.props.onRequestClose} />
            )}
          </div>
        )
      } else if (this.props.onRequestClose) {
        if (this.props.closeIcon) {
          return (
            <span className="checkout-tray__close-button" onClick={this.props.onRequestClose}>
              {this.props.closeIcon}
            </span>
          )
        } else {
          return (
            <div className="checkout-tray__header-no-border">
              {this.props.showCloseButton && (
                <span className="checkout-tray__close-button" onClick={this.props.onRequestClose} />
              )}
            </div>
          )
        }
      } else {
        return null
      }
    })()

    return (
      <Dropdown appear={this.props.shouldDropDown} fullScreen={true} showCloseButton={false}>
        {this.props.children && (
          <Scroller ref="scroller" id="checkout-tray__scroller" className={this.props.className}>
            <div>
              {this.props.showHeader && header}
              <div className="checkout-tray__content">{this.props.children}</div>
            </div>
          </Scroller>
        )}
      </Dropdown>
    )
  }
}

export default Tray
